module.exports = __webpack_public_path__ + "static/media/clammer_feed.67614274.png";